import { render, staticRenderFns } from "./rewardDistributionDetails.vue?vue&type=template&id=7a39f579&scoped=true"
import script from "./rewardDistributionDetails.vue?vue&type=script&lang=js"
export * from "./rewardDistributionDetails.vue?vue&type=script&lang=js"
import style0 from "./rewardDistributionDetails.vue?vue&type=style&index=0&id=7a39f579&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39f579",
  null
  
)

export default component.exports